import { EditLined } from '@tag/tag-icons';

import styles from './edit-icon.module.scss';

export default function EditIcon() {
  return (
    <div className={styles.wrapper}>
      <EditLined
        accent="white"
      />
    </div>
  );
}
